import { APPLE_DEVICES } from '../utils/constants';
import { Device } from '@ionic-enterprise/device';
import { isPlatform } from '@ionic/react';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { Diagnostic } from '@ionic-native/diagnostic';

export const capitalize = (str: any, lower = false) =>
  (lower ? str.toLowerCase() : str).replace(
    /(?:^|\s|["'([{])+\S/g,
    (match: any) => match.toUpperCase()
  );

export const deviceModel = () => {
  const model = APPLE_DEVICES.find(
    device => device.identifier === Device.model
  );
  return model ? model.generation : Device.model;
};

export const manufacturer = () => Device.manufacturer;
export const manufacturerForAndroid = () =>
  isPlatform('android') ? Device.manufacturer : '';
export const operationSystem = () => Device.platform;
export const osVersion = () => Device.version;
export const osAndVersion = () => `${operationSystem} ${osVersion}`;
export const isAndroid11 = () => operationSystem() === "Android" && parseInt(osVersion()) >= 11;
export const isAndroid10AndAbove = () => operationSystem() === "Android" && parseInt(osVersion()) >= 10;
const ACCESS_FINE_LOCATION = "android.permission.ACCESS_FINE_LOCATION";
const ACCESS_BACKGROUND_LOCATION = "android.permission.ACCESS_BACKGROUND_LOCATION";
const ACTIVITY_RECOGNITION = "android.permission.ACTIVITY_RECOGNITION";

export async function checkLocationAndPhysicalActivityPermission() {
  let isPermissionsAvailable = false;
  let isPhysicalActivityPermission = true;
  if (operationSystem() === "Android") {
    let isLocationPermission = await AndroidPermissions.requestPermission(ACCESS_FINE_LOCATION).then(status => status.hasPermission).catch((e)=>false);
    if (isAndroid10AndAbove()) {
      isLocationPermission = await AndroidPermissions.requestPermission(ACCESS_BACKGROUND_LOCATION).then(status => status.hasPermission).catch((e)=>false);
      isPhysicalActivityPermission = await AndroidPermissions.requestPermission(ACTIVITY_RECOGNITION).then(status => status.hasPermission).catch((e)=>false);
    }
    isPermissionsAvailable = isPhysicalActivityPermissionCheck(isLocationPermission, isPhysicalActivityPermission);
  }
  else if(operationSystem() === "iOS") {
    let isLocationPermissioniOS = false;
    let iosMotionPermission = "";
    let motionPermissionStatus = "";
    const iOSLocationPermission = await Diagnostic.getLocationAuthorizationStatus().then(status => status).catch((e) => "");
    if (permissionCheck(iOSLocationPermission)) {
      const result = await Diagnostic.requestLocationAuthorization(Diagnostic.locationAuthorizationMode.WHEN_IN_USE).then(status => status).catch((e) => "");
      isLocationPermissioniOS = await getPermission(result, isLocationPermissioniOS);
    }
    else {
      isLocationPermissioniOS = getIOSLocationPermission(iOSLocationPermission, isLocationPermissioniOS);
    }
    motionPermissionStatus = await Diagnostic.getMotionAuthorizationStatus().then(result => result).catch((e) => "");
    if (getMotionPermissionStatusCheck(motionPermissionStatus)) 
      {
          iosMotionPermission = await Diagnostic.requestMotionAuthorization().then(result => result).catch((e) => "");
      }
    let isMotionPermissionGranted = iosMotionPermission === Diagnostic.motionStatus.GRANTED || motionPermissionStatus === Diagnostic.motionStatus.GRANTED;
    let deviceNotCapableForMotion = motionPermissionStatus === Diagnostic.motionStatus.NOT_AVAILABLE || motionPermissionStatus === Diagnostic.motionStatus.NOT_DETERMINED;
    isPermissionsAvailable = isLocationAvailableCheck(isLocationPermissioniOS, isMotionPermissionGranted, deviceNotCapableForMotion);
  }
  else{
    isPermissionsAvailable = true;
  }
  return isPermissionsAvailable;
};

export const checkLocationPermission = () => {
  AndroidPermissions.checkPermission(AndroidPermissions.PERMISSION.ACCESS_FINE_LOCATION).then(
      result => {
          if (!result.hasPermission) {
              AndroidPermissions.requestPermissions(
                  [AndroidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
                  AndroidPermissions.PERMISSION.ACCESS_COARSE_LOCATION,
                  AndroidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION
                  ]);
          }

      },
      err => {
          AndroidPermissions.requestPermissions(
              [AndroidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
              AndroidPermissions.PERMISSION.ACCESS_COARSE_LOCATION,
              AndroidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION
              ]);
      }
  );
}

function isLocationAvailableCheck(isLocationPermissioniOS: boolean, isMotionPermissionGranted: boolean, deviceNotCapableForMotion: boolean): boolean {
  return isLocationPermissioniOS && (isMotionPermissionGranted || deviceNotCapableForMotion);
}

function isPhysicalActivityPermissionCheck(isLocationPermission: boolean, isPhysicalActivityPermission: boolean): boolean {
  return isLocationPermission && isPhysicalActivityPermission;
}

function getMotionPermissionStatusCheck(motionPermissionStatus: string) {
  return motionPermissionStatus !== Diagnostic.motionStatus.DENIED &&
    motionPermissionStatus !== Diagnostic.motionStatus.GRANTED &&
    motionPermissionStatus !== Diagnostic.motionStatus.RESTRICTED &&
    motionPermissionStatus !== Diagnostic.motionStatus.UNKNOWN &&
    motionPermissionStatus !== Diagnostic.motionStatus.NOT_AVAILABLE &&
    motionPermissionStatus !== Diagnostic.motionStatus.NOT_DETERMINED;
}

function getIOSLocationPermission(iOSLocationPermission: any, isLocationPermissioniOS: boolean) {
  if (iOSLocationPermission === Diagnostic.permissionStatus.GRANTED_WHEN_IN_USE || iOSLocationPermission === Diagnostic.permissionStatus.GRANTED) {
    if (parseInt(osVersion()) >= 13) {
      isLocationPermissioniOS = (iOSLocationPermission === Diagnostic.permissionStatus.GRANTED);
    }
    else {
      isLocationPermissioniOS = true;
    }
  }
  return isLocationPermissioniOS;
}

function permissionCheck(iOSLocationPermission: any) {
  return iOSLocationPermission !== Diagnostic.permissionStatus.DENIED_ALWAYS &&
    iOSLocationPermission !== Diagnostic.permissionStatus.GRANTED_WHEN_IN_USE &&
    iOSLocationPermission !== Diagnostic.permissionStatus.GRANTED;
}

async function getPermission(result: any, isLocationPermissioniOS: boolean) {
  if (result === Diagnostic.permissionStatus.GRANTED || result === Diagnostic.permissionStatus.GRANTED_WHEN_IN_USE) {
    isLocationPermissioniOS = true;
    //Request for background geolocation if location permission available as Granted when in use. 
    if (result === Diagnostic.permissionStatus.GRANTED_WHEN_IN_USE && parseInt(osVersion()) >= 13) {
      await Diagnostic.requestLocationAuthorization(Diagnostic.locationAuthorizationMode.ALWAYS)
        .then((status) => {
          isLocationPermissioniOS = (status === Diagnostic.permissionStatus.GRANTED);
        })
        .catch((e) => { isLocationPermissioniOS = false; });
    }
  }
  return isLocationPermissioniOS;
}

